import { render } from "./ModuleDeactivation.vue?vue&type=template&id=940526fc"
import script from "./ModuleDeactivation.vue?vue&type=script&lang=js"
export * from "./ModuleDeactivation.vue?vue&type=script&lang=js"

import "./ModuleDeactivation.vue?vue&type=style&index=0&id=940526fc&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__